import React from 'react';
import Paper from '@material-ui/core/Paper';
import Badge from '@material-ui/core/Badge';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  listItemContent: {
    width: '100%',
    padding: '0 15px 15px',
    margin: '13px 0',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: props => `rgb(${props.configColors['--color_7']})`
  },
  itemHeaderContainer: {
    display: 'flex',
    flexDirection : 'row',
    justifyContent : 'space-between'
  },
  listItemContentContainer: {
    width: "100%",    
  },
  itemComputedTime: {
    paddingTop: '2px',
    textAlign: 'right',
    color : props => `rgb(${props.configColors['--color_3']})`,
    fontSize: '12px',
    lineHeight: '20px',
    opacity: '0.3',
    width: '100%'
  },
  itemHeader:{
    color: props => `rgb(${props.configColors['--color_3']})`,
    fontSize: '14px',
    lineHeight: '24px',
    fontWeight: 'bold'
  },
  itemDescription:{
    color: props => `rgb(${props.configColors['--color_3']})`,
    fontSize: '13px',
    lineHeight: '24px'
  },
  readMore:{
    color: props => `rgb(${props.configColors['--color_1']})`,

  },
  badgeStyle:{
    right: 'inherit',
    backgroundColor: props => props.bannerBg,
    padding : '0 15px',
    margin: '8px',
    left: '7px',
    top: '-5px',
    transform: 'none',
    height: '24px',
    borderRadius: '12px'
  }

});

export default function BCLStyledListItem(props){

  const classes = useStyles(props);

  return (
    <div > 
        <Badge badgeContent={props.type} color="primary" className={classes.listItemContentContainer} classes={{badge: classes.badgeStyle}}>
          <Paper className={classes.listItemContent} elevation={0}>
            <div className={classes.itemHeaderContainer}>
              <div className={classes.itemComputedTime}>{props.itemComputedTime}</div>
            </div>
              <span className={classes.itemHeader}>{props.title}</span>
              <span className={classes.itemDescription}>
                { props.description }
                { props.redirectCTA ? <Button variant="text" className={classes.readMore} disableRipple> Read More </Button> : ''}
              </span>
          </Paper>
        </Badge>
    </div>
  )
}
